// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-buttons-container {
  height: 15%; 
  width: 100%; 
  display: flex; 
  justify-content: flex-end;
  align-items: center; 
  padding: 16px 30px;
  margin-top: 20px; 
  margin-right: 20px; 
  gap: 10px;
}

.footer-button {
  background: #ffffff; 
  color: #004481;
  border-radius: 25px; 
  padding: 8px 16px; 
  font-size: 16px; 
  font-weight: 600; 
  border: 1px solid #004481; 
  transition: background-color 0.3s, color 0.3s, border-color 0.3s; 
}

.footer-button:hover {
  background: #f0f5ff ; 
  color: #003366;
  border-color: #003366; 
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Button/ActionButton.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,qBAAqB;AACvB","sourcesContent":[".footer-buttons-container {\n  height: 15%; \n  width: 100%; \n  display: flex; \n  justify-content: flex-end;\n  align-items: center; \n  padding: 16px 30px;\n  margin-top: 20px; \n  margin-right: 20px; \n  gap: 10px;\n}\n\n.footer-button {\n  background: #ffffff; \n  color: #004481;\n  border-radius: 25px; \n  padding: 8px 16px; \n  font-size: 16px; \n  font-weight: 600; \n  border: 1px solid #004481; \n  transition: background-color 0.3s, color 0.3s, border-color 0.3s; \n}\n\n.footer-button:hover {\n  background: #f0f5ff ; \n  color: #003366;\n  border-color: #003366; \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
